'use client';
import React from 'react';

interface CommunityCard {
  title: string;
  image: string;
  alt: string;
  href: string;
}

const communityCards: CommunityCard[] = [
{
  title: 'Social\nImpact',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_16146106f-1779936772629.png",
  alt: 'Community members participating in social impact programs and neighborhood improvement activities',
  href: '#community'
},
{
  title: 'Supportive\nServices',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f672c953-1779936775511.png",
  alt: 'Residents receiving supportive services including counseling, job training, and community resources',
  href: '#community'
},
{
  title: 'Scholarships',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18a71e5de-1777684033993.png",
  alt: 'Students receiving educational scholarships to pursue higher education and career opportunities',
  href: '#community'
},
{
  title: 'Sustainability',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1611f48a4-1769435294375.png",
  alt: 'Green building and sustainability initiatives including solar panels and eco-friendly landscaping',
  href: '#community'
}];


export default function CommunitySection() {
  return (
    <section
      id="community"
      className="relative bg-white py-12 md:py-16 lg:py-20">

      {/* Background pattern */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url('https://tmo.com/wp-content/uploads/2024/07/pattern-bg-01.png')`,
          backgroundRepeat: 'repeat',
          opacity: 0.2,
          pointerEvents: 'none'
        }} />


      <div className="relative" style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
        {/* Section Header */}
        <div className="mb-8 md:mb-10">
          <h2
            style={{
              fontSize: 'clamp(24px, 3vw, 36px)',
              fontWeight: 400,
              color: '#003c82',
              margin: 0,
              fontFamily: 'Montserrat, sans-serif'
            }}>

            Building Better Lives
          </h2>
        </div>

        {/* Cards Grid — 1 col mobile, 2 col sm, 4 col lg */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {communityCards.map((card) =>
          <a
            key={card.title}
            href={card.href}
            style={{ textDecoration: 'none', display: 'block' }}>

              <div
              style={{
                position: 'relative',
                overflow: 'hidden',
                cursor: 'pointer'
              }}>

                {/* Image */}
                <div style={{ overflow: 'hidden' }}>
                  <img
                  src={card.image}
                  alt={card.alt}
                  style={{
                    width: '100%',
                    height: '220px',
                    objectFit: 'cover',
                    display: 'block',
                    transition: 'transform 0.4s ease'
                  }}
                  onMouseEnter={(e) => {(e.currentTarget as HTMLImageElement).style.transform = 'scale(1.05)';}}
                  onMouseLeave={(e) => {(e.currentTarget as HTMLImageElement).style.transform = 'scale(1)';}} />

                </div>

                {/* Overlay */}
                <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 60%)'
                }} />


                {/* Content */}
                <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: '20px',
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between'
                }}>

                  <h3
                  style={{
                    color: '#ffffff',
                    fontSize: '18px',
                    fontWeight: 500,
                    margin: 0,
                    fontFamily: 'Montserrat, sans-serif',
                    whiteSpace: 'pre-line'
                  }}>

                    {card.title}
                  </h3>
                  <svg width="32" height="16" viewBox="0 0 39 32" fill="none" style={{ color: '#ffffff', flexShrink: 0 }}>
                    <path d="M22.721 1.228l15.015 15.015-15.015 15.015" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M37.791 16.242h-37.606" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
            </a>
          )}
        </div>
      </div>
    </section>);

}